import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Tooltip,
  Popconfirm,
  notification,
  Drawer,
  Button,
  Timeline,
} from "antd";
import {
  OrderedListOutlined,
  RollbackOutlined,
  InfoCircleOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import { ColumnHelper } from "../../util/TableHelper";
import { useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import ProjectStepListFilter from "../Filters/ProjectStepListFilter";
import moment from "moment";
import ProjectStepUpdateForm from "../Forms/ProjectStepUpdateForm";
import ProjectStepNoteAddForm from "../Forms/ProjectStepNoteAddForm";
import { Link } from "react-router-dom";

const ProjectStepByProjectList = (props) => {
  const [options, setOptions] = useState({
    pageTitle: "PROJE ADIMLARI",
  });
  const [tableData, setTableData] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [totalProjectStepCount, setTotalProjectStepCount] = useState(0);
  const [firmName, setFirmName] = useState("");
  const [updateFormData, setUpdateFormData] = useState({});
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [projectStepId, setProjectStepId] = useState(null);
  const [addProjectStepNoteVisibility, setAddProjectStepNoteVisibility] =
    useState(false);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [isEditAllowed, setIsEditAllowed] = useState(true);

  useEffect(
    () => getTableData(),
    [props.match.params.firmId, tableDataQueryOptions]
  );

  useEffect(() => {
    RequestHandler.get(`/User/GetTenantUserDetail`).then((response) => {
      if (response.success) {
        if (response.data.isAdmin === false) {
          setIsEditAllowed(false);
        }
      }
    });
    RequestHandler.get(`/Firm/GetById/${props.match.params.firmId}`).then(
      (response) => {
        setFirmName(response.name);
      }
    );
  }, []);

  const history = useHistory();

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/ProjectStep/${props.match.params.firmId}?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response?.value,
        loading: false,
        total: response["@odata.count"],
      });

      if (conditions.length == 0) {
        setTotalProjectStepCount(response["@odata.count"]);
      }
    });
  };

  useEffect(() => {
    if (tableData.data?.length > 0) {
      setExpandedRowKeys(tableData.data.slice(0, 3).map((item) => item.id));
    }
  }, [tableData.data]);

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan Proje Adımı güncellenemez.",
    });
  };
  const columns = [
    {
      title: "Ad",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";
        else
          return (
            <Tooltip title={text}>
              <span>
                {text.substring(0, 40).length < 40
                  ? text.substring(0, 40) + ""
                  : text.substring(0, 40) + "..."}
              </span>
            </Tooltip>
          );
      },
    },
    {
      title: "Eklenme Tarihi",
      dataIndex: "addDate",
      key: "addDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY HH:mm") : "-"),
    },
    {
      title: "Başlangıç Tarihi",
      dataIndex: "startDate",
      key: "startDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY") : "-"),
    },
    {
      title: "Bitiş Tarihi",
      dataIndex: "endDate",
      key: "endDate",
      render: (data) => (data ? moment(data).format("DD.MM.YYYY") : "-"),
    },

    {
      title: "Durum",
      dataIndex: "status",
      align: "center",
      render: (i, row) => {
        const icon = {
          NotStarted: {
            color: "blue",
            component: <InfoCircleOutlined />,
          },
          Active: {
            color: "orange",
            component: <ClockCircleOutlined />,
          },
          Completed: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
        };
        return (
          <Tooltip title={row.statusDescription}>
            <a style={{ fontSize: "130%", color: icon[i].color }}>
              {icon[i].component}
            </a>
          </Tooltip>
        );
      },
    },
    {
      title: "Proje Adımı Notları",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "9%",
      render: (text, record) => (
        <Link
          style={{ fontSize: "120%", color: "purple", paddingTop: 10 }}
          to={`/project-step-note/${record.id}`}
        >
          <OrderedListOutlined />
        </Link>
      ),
    },
    {
      title: "Proje Adımı Not Girişi",
      dataIndex: "id",
      align: "center",
      key: "id",
      width: "8%",
      render: (text, record) => (
        <Button
          onClick={() => {
            if (record.isActive) {
              setAddProjectStepNoteVisibility(true);
              setProjectStepId(record.id);
            } else {
              openNotificationWithIcon("warning");
            }
          }}
          icon={<AppstoreAddOutlined />}
          type="link"
          style={{ fontSize: "120%", color: "#9254de", paddingTop: 7 }}
        ></Button>
      ),
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        tableData.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    ...(isEditAllowed
      ? [
          {
            title: "Sil",
            dataIndex: "id",
            width: "1%",
            render: (data) => (
              <Popconfirm
                title="Silmek istiyor musunuz?"
                okText="Evet"
                cancelText="Hayır"
                onConfirm={() => handleOnClickDelete(data)}
              >
                <a style={{ color: "red", fontSize: "130%" }}>
                  <DeleteOutlined />
                </a>
              </Popconfirm>
            ),
          },
        ]
      : []),
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/ProjectStep/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };
  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/ProjectStep/GetById/${record.id}`).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });
  };

  const onUpdateProjectStepSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
    setAddProjectStepNoteVisibility(false);
  };

  return (
    <>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={18} lg={6} style={{ textAlign: "right" }}>
          <span style={{ marginRight: 50, fontSize: 16 }}>
            {" "}
            Toplam Proje Adımı Sayısı: {totalProjectStepCount}
          </span>
        </Col>
        <Col xs={24} md={6} lg={2} style={{ textAlign: "start", fontSize: 19 }}>
          <p style={{ fontWeight: "bold", color: "#2c3e50" }}>
            <span style={{ color: "#6f5196" }}>{firmName}</span>
          </p>
        </Col>
      </Row>
      <ProjectStepListFilter
        firmId={props.match.params.firmId}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        isUseStockId={false}
        style={{ marginTop: 12, marginBottom: 12 }}
        extraText="Proje Adımlarının sol tarafında bulunan + tuşuna tıklayarak, ilgili Proje Adımına girilen notları hiyerarşik şekilde görüntüleyebilirsiniz."
      />
      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            expandable={{
              expandedRowRender: (record) => (
                <>
                  <Timeline mode="left" style={{ marginTop: 20 }}>
                    {(record.notes || []).length > 0 ? (
                      (record.notes || []).map((note, index) => (
                        <Timeline.Item
                          label={moment(note.addDate).format(
                            "DD.MM.YYYY HH:mm"
                          )}
                          key={index}
                        >
                          {note.note}
                        </Timeline.Item>
                      ))
                    ) : (
                      <Timeline.Item color="gray">Henüz not yok.</Timeline.Item>
                    )}
                  </Timeline>
                </>
              ),
              rowExpandable: (record) =>
                (record.notes && record.notes.length > 0) || true,
              expandedRowKeys: expandedRowKeys,
              onExpandedRowsChange: (keys) => setExpandedRowKeys(keys),
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            onChange={paging}
            dataSource={tableData.data}
            loading={tableData.loading}
            pageable={true}
            pagination={{
              pageSizeOptions: ["20", "50", "100"],
              total: tableData.total,
              defaultPageSize: tableDataQueryOptions.take,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
            rowClassName={(record, index) =>
              record?.status == "Active"
                ? "table-row-yellow"
                : record?.status == "Completed"
                ? "table-row-green"
                : "table-row-default"
            }
          ></Table>
        </Col>
      </Row>

      <Drawer
        id="updateProjectStepDrawer"
        title="Proje Adımı Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <ProjectStepUpdateForm
          data={updateFormData}
          onSuccess={onUpdateProjectStepSuccess}
        />
      </Drawer>

      <Drawer
        id="addProjectStepNote"
        title="Proje Adımı Not Girişi"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddProjectStepNoteVisibility(false)}
        visible={addProjectStepNoteVisibility}
        destroyOnClose={true}
      >
        <ProjectStepNoteAddForm
          projectStepId={projectStepId}
          onSuccess={onUpdateProjectStepSuccess}
        />
      </Drawer>
    </>
  );
};

export default ProjectStepByProjectList;
